<template lang="html">

  <article class="video-el column-center" :style="`background: url(${data.snippet.thumbnails.high.url}) center/cover no-repeat`">

    <h3 class="title" v-html="data.snippet.title"></h3>

    <a @click="$emit('sendVideo', data.snippet.resourceId.videoId)" class="enlace-cover"></a>

    <img src="/static/img/play.svg" class="play-img">

  </article>

</template>

<script lang="js">
  export default  {
    name: 'video-el',
    props: ['data']
  }
</script>

<style scoped lang="scss">
  .video-el {
    width: calc(33% - 15px);
    margin-right: 20px;
    color: black;
    height: 214px;
    margin-bottom: 20px;
    position: relative;
    padding: 15px;
    overflow: hidden;

    &:nth-child(3n){
      margin-right: 0;
    }


    .enlace-cover{
      background: -moz-linear-gradient(top, rgba(0,0,0,0.7) 0%, rgba(0,0,0,0.3) 100%); /* FF3.6-15 */
      background: -webkit-linear-gradient(top, rgba(0,0,0,0.7) 0%,rgba(0,0,0,0.3) 100%); /* Chrome10-25,Safari5.1-6 */
      background: linear-gradient(to bottom, rgba(0,0,0,0.7) 0%,rgba(0,0,0,0.3) 100%); /* W3C, IE10+, FF16+, Chrome26+, Opera12+, Safari7+ */
      filter: progid:DXImageTransform.Microsoft.gradient( startColorstr='#b3000000', endColorstr='#4d000000',GradientType=0 ); /* IE6-9 */
    }

    .title{
      font-size: 18px;
      line-height: 20px;
      letter-spacing: 3px;
      position: relative;
      z-index: 6;
      pointer-events: none;
      text-align: center;
      pointer-events: none;
      transition: .5s;
      &::before{
        left:50%;
        margin-left: -22.5px;
      }
    }

    .play-img{
      position: absolute;
      left: 50%;
      top: 50%;
      z-index: 7;
      pointer-events: none;
      margin-left: -27px;
      margin-top: -27px;
      opacity: 0;
      transform: translateY(100px);
      transition: .5s;
    }

    &:hover{

      .title{
        transform: translateY(-150px);
        opacity: 0;
      }

      .play-img{
        transform: translateY(0);
        opacity: 1;
      }

    }
  }


  @media screen and (max-width: 1023px){
    .video-el{
      width: calc(50% - 10px);
      height: 26vw;
      margin-right: 0;
      &:nth-child(2n-1){
        margin-right: 20px;
      }
    }
  }

  @media screen and (max-width: 600px){
    .video-el{
      width: 100%;
      height: 46vw;
      &:nth-child(2n-1){
        margin-right: 0px;
      }
    }
  }


</style>



// WEBPACK FOOTER //
// src/components/parts/video-el.vue